/* PronunciationQualityBanner — fetches /api/admin/audio-status (open via
   /api/audio/quality if we expose it) and shows a soft note for the
   currently-active language reminding users that AI pronunciation may be
   approximate for some heritage languages.
   Renders only for languages flagged 'approximate' or 'medium'. */
import React, { useEffect, useState } from 'react';
import { Volume2, Users2 } from 'lucide-react';
import { api } from '@/lib/api';

const COPY = {
    approximate: 'AI pronunciation for this language is currently an approximation — best double-checked with a family member, classmate, or teacher. Native-speaker QA is in progress.',
    medium: 'AI pronunciation is decent for this language but not perfect — your family or teacher will catch the nuances we miss.',
    native: '',
    unknown: '',
};

export default function PronunciationQualityBanner({ languageSlug, className = '' }) {
    const [info, setInfo] = useState(null);
    useEffect(() => {
        let alive = true;
        api.get('/audio/quality').then(({ data }) => {
            if (alive) setInfo((data.languages || []).find((l) => l.slug === languageSlug));
        }).catch(() => {});
        return () => { alive = false; };
    }, [languageSlug]);

    if (!info) return null;
    const text = COPY[info.pronunciation_quality] || '';
    if (!text) return null;
    return (
        <div className={`inline-flex items-start gap-3 rounded-xl bg-lq-peach-100 border border-lq-peach-300 px-4 py-3 ${className}`} data-testid="pronunciation-banner">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-lq-peach-300 text-lq-peach-700 inline-flex items-center justify-center"><Volume2 size={14} /></div>
            <div className="text-xs text-lq-ink-700 leading-snug">
                <strong className="text-lq-ink-900">A note on the voice.</strong>{' '}
                {text}
                <span className="ml-1 inline-flex items-center gap-1 text-lq-purple-700 font-semibold">
                    <Users2 size={12} /> Best played with someone who knows the language.
                </span>
            </div>
        </div>
    );
}
